/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  V1DeployDeploymentStep,
  V1DeployDeploymentStep$inboundSchema,
} from "./v1deploydeploymentstep.js";

/**
 * Current deployment status
 */
export const V1DeployGetDeploymentResponseDataStatus = {
  Unspecified: "UNSPECIFIED",
  Pending: "PENDING",
  Starting: "STARTING",
  Building: "BUILDING",
  Deploying: "DEPLOYING",
  Network: "NETWORK",
  Finalizing: "FINALIZING",
  Ready: "READY",
  Failed: "FAILED",
  Skipped: "SKIPPED",
  AwaitingApproval: "AWAITING_APPROVAL",
  Stopped: "STOPPED",
  Superseded: "SUPERSEDED",
  Cancelled: "CANCELLED",
} as const;
/**
 * Current deployment status
 */
export type V1DeployGetDeploymentResponseDataStatus = OpenEnum<
  typeof V1DeployGetDeploymentResponseDataStatus
>;

export type V1DeployGetDeploymentResponseData = {
  /**
   * Unique deployment identifier
   */
  id: string;
  /**
   * Current deployment status
   */
  status: V1DeployGetDeploymentResponseDataStatus;
  /**
   * Error message if deployment failed
   */
  errorMessage?: string | undefined;
  /**
   * Hostnames associated with this deployment
   */
  hostnames?: Array<string> | undefined;
  /**
   * Deployment steps with status and messages
   */
  steps?: Array<V1DeployDeploymentStep> | undefined;
};

/** @internal */
export const V1DeployGetDeploymentResponseDataStatus$inboundSchema: z.ZodType<
  V1DeployGetDeploymentResponseDataStatus,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(V1DeployGetDeploymentResponseDataStatus);

/** @internal */
export const V1DeployGetDeploymentResponseData$inboundSchema: z.ZodType<
  V1DeployGetDeploymentResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  status: V1DeployGetDeploymentResponseDataStatus$inboundSchema,
  errorMessage: z.string().optional(),
  hostnames: z.array(z.string()).optional(),
  steps: z.array(V1DeployDeploymentStep$inboundSchema).optional(),
});

export function v1DeployGetDeploymentResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1DeployGetDeploymentResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1DeployGetDeploymentResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1DeployGetDeploymentResponseData' from JSON`,
  );
}
